import React from 'react'
import { Dialog, Button, Typography } from '@hubii/ds-hubii'

type Props = {
  open: boolean
  targetHubName: string
  currentHubName: string
  onConfirm: () => void
  onCancel: () => void
}

const HubSwitchModal: React.FC<Props> = ({
  open,
  targetHubName,
  currentHubName,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog isOpen={open} onClose={onCancel} dataTestId='hub-switch-modal' size='small'>
      <div className='w-full'>
        <div className='border-b border-neutral-200 pb-2 p-4 w-full'>
          <Typography variant='h5'>Trocar de Hub?</Typography>
        </div>
        <div className='flex flex-col gap-2 p-4 w-full border-b border-neutral-200'>
          <Typography variant='body1' className='mb-2'>
            Você está atualmente gerenciando o Hub <strong>{currentHubName}</strong>, mas esta
            notificação é do Hub <strong>{targetHubName}</strong>.
          </Typography>

          <Typography variant='body1' className='mb-2'>
            Deseja mudar para o Hub {targetHubName} para visualizar este pedido?
          </Typography>
        </div>
        <div className='flex justify-end gap-2 p-4 w-full '>
          <Button onClick={onCancel} color='neutral' dataTestId='cancel-hub-switch'>
            Cancelar
          </Button>
          <Button onClick={onConfirm} color='primary' dataTestId='confirm-hub-switch'>
            Trocar de Hub
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default HubSwitchModal
